import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import MeasuredGrid from './MeasuredGrid';
import { adjustBreakpointHeight, DEFAULT_BREAKPOINTS } from './breakpoints';
export const StandardGrid = (_param)=>/*#__PURE__*/ {
    var { adjustHeight =0 , breakpoints =DEFAULT_BREAKPOINTS , children  } = _param, props = _object_without_properties(_param, [
        "adjustHeight",
        "breakpoints",
        "children"
    ]);
    return React.createElement(MeasuredGrid, _extends({}, props, {
        breakpoints: adjustHeight ? adjustBreakpointHeight(breakpoints, adjustHeight) : breakpoints,
        renderElement: children
    }));
};
export default StandardGrid;
